import React, { useEffect, useRef, useState } from "react";

function Newzealandworkingvisaimport() {
  const [activeIndex, setActiveIndex] = useState(0);
  const sectionRefs = useRef([]);
  const contentRef = useRef(null);

  useEffect(() => {
    sectionRefs.current = sectionRefs.current.slice(0, 5);

    const observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: 0.1,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const index = sectionRefs.current.indexOf(entry.target);
          setActiveIndex(index);
        }
      });
    }, observerOptions);

    sectionRefs.current.forEach((section) => {
      observer.observe(section);
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  const scrollToSection = (index) => {
    setActiveIndex(index);
    const section = sectionRefs.current[index];
    const contentElement = contentRef.current;

    const scrollPosition = section.offsetTop - contentElement.offsetTop;

    contentElement.scrollTo({
      top: scrollPosition,
      behavior: "smooth",
    });
  };

  return (
    <div className="flex flex-wrap">
      {/* Left-side Navigation */}
      <div className="sticky top-0 h-screen w-1/4 bg-gray-100 p-4 hidden md:block">
        <ul className="space-y-4">
          <li
            onClick={() => scrollToSection(0)}
            className={`cursor-pointer p-4 rounded-md shadow-md ${
              activeIndex === 0
                ? "bg-blue-500 text-white"
                : "bg-white text-[#2C3F69]"
            }`}
          >
            General Entry Requirements
          </li>
          <li
            onClick={() => scrollToSection(1)}
            className={`cursor-pointer p-4 rounded-md shadow-md ${
              activeIndex === 1
                ? "bg-blue-500 text-white"
                : "bg-white text-[#2C3F69]"
            }`}
          >
            Visa Categories
          </li>
          <li
            onClick={() => scrollToSection(2)}
            className={`cursor-pointer p-4 rounded-md shadow-md ${
              activeIndex === 2
                ? "bg-blue-500 text-white"
                : "bg-white text-[#2C3F69]"
            }`}
          >
            Essential Skills Work Visa
          </li>
          <li
            onClick={() => scrollToSection(3)}
            className={`cursor-pointer p-4 rounded-md shadow-md ${
              activeIndex === 3
                ? "bg-blue-500 text-white"
                : "bg-white text-[#2C3F69]"
            }`}
          >
            Pathways to Residency
          </li>
          <li
            onClick={() => scrollToSection(4)}
            className={`cursor-pointer p-4 rounded-md shadow-md ${
              activeIndex === 4
                ? "bg-blue-500 text-white"
                : "bg-white text-[#2C3F69]"
            }`}
          >
            Application Process
          </li>
        </ul>
      </div>

      {/* Content Section */}
      <div
        ref={contentRef}
        className="mb-10 h-screen overflow-y-auto p-4 w-full md:w-3/4"
      >
        <div ref={(el) => (sectionRefs.current[0] = el)}>
          <p className="text-xl font-bold text-[#011473]">
            General Entry Requirements
          </p>
          <ul className="mt-4 list-disc pl-6 text-[#2C3F69]">
            <li>
              <strong>Health and Character:</strong> You must be in good health
              and have a clean character record.
            </li>
            <li>
              <strong>Valid Passport:</strong> Your passport should remain valid
              for at least three months beyond your intended departure date.
            </li>
            <li>
              <strong>Genuine Intent:</strong> You should have a legitimate
              purpose for working in New Zealand.
            </li>
            <li>
              <strong>Appropriate Visa:</strong> Ensure you hold the correct
              visa for your visit.
            </li>
          </ul>
        </div>

        <div ref={(el) => (sectionRefs.current[1] = el)} className="mt-10">
          <p className="text-lg font-semibold text-[#011473]">Visa Categories</p>
          <p className="mt-4 text-[#2C3F69]">
            Additional requirements vary depending on the visa category you are
            applying for. New Zealand offers various categories tailored to
            different circumstances.
          </p>
        </div>

        <div ref={(el) => (sectionRefs.current[2] = el)} className="mt-10">
          <p className="text-lg font-semibold text-[#011473]">
            Essential Skills Work Visa
          </p>
          <ul className="mt-4 list-disc pl-6 text-[#2C3F69]">
            <li>
              The employer must demonstrate that no New Zealand citizens or
              residents are available for the role. This can be shown by:
              <ul className="mt-2 list-disc pl-6">
                <li>
                  Confirming the job is on the Essential Skills in Demand List.
                </li>
                <li>
                  Providing evidence of genuine efforts to recruit locally.
                </li>
              </ul>
            </li>
            <li>
              You must possess the necessary qualifications, training, or
              experience for the role.
            </li>
          </ul>
        </div>

        <div ref={(el) => (sectionRefs.current[3] = el)} className="mt-10">
          <p className="text-lg font-semibold text-[#011473]">
            Pathways to Residency
          </p>
          <ul className="mt-4 list-disc pl-6 text-[#2C3F69]">
            <li>
              <strong>Skilled Migrant Category:</strong> For individuals with
              skills and experience that align with New Zealand's needs.
            </li>
            <li>
              <strong>Work to Residence:</strong> A pathway for individuals with
              in-demand qualifications, job offers from accredited employers, or
              exceptional talent in sports or the arts.
            </li>
            <li>
              <strong>Residence from Work:</strong> For those already in New
              Zealand on a Work to Residence visa transitioning to permanent
              residency.
            </li>
          </ul>
        </div>

        <div ref={(el) => (sectionRefs.current[4] = el)} className="mt-10">
          <p className="text-lg font-semibold text-[#011473]">
            Application Process
          </p>
          <ul className="mt-4 list-disc pl-6 text-[#2C3F69]">
            <li>
              <strong>Expression of Interest (EOI):</strong> Submit an EOI with
              personal, family, skills and work experience details.
            </li>
            <li>
              <strong>Invitation to Apply:</strong> If your EOI meets the points
              threshold, you’ll receive an invitation to submit a full
              application.
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Newzealandworkingvisaimport;
